import { Navigate, Route, Routes } from 'react-router-dom';

// Pages
import { Proximamente } from '../../../pages';

export function RouterProximamente() {
  return (
    <Routes>
      <Route path="/home" element={<Proximamente />} />
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
}
